import React from 'react';
import KycGenericVerification from './KycGenericVerification';

export default function KycDlVerification() {
  const formatDobInput = (value) => {
    const digits = String(value || '').replaceAll(/\D/g, '').slice(0, 8);
    if (digits.length === 0) return '';
    if (digits.length === 1) return digits;
    if (digits.length === 2) return `${digits}/`;
    if (digits.length === 3) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    if (digits.length === 4) return `${digits.slice(0, 2)}/${digits.slice(2)}/`;
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
  };

  const normalizeDob = (value) => {
    const input = String(value || '').trim();
    if (!input) return '';

    if (/^\d{8}$/.test(input)) {
      return `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4)}`;
    }

    if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(input)) {
      return input.replaceAll('-', '/');
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [year, month, day] = input.split('-');
      return `${day}/${month}/${year}`;
    }

    return input;
  };

  const isValidDob = (value) => {
    const input = String(value || '').trim();
    return /^\d{8}$/.test(input)
      || /^\d{2}[-/]\d{2}[-/]\d{4}$/.test(input)
      || /^\d{4}-\d{2}-\d{2}$/.test(input);
  };

  return (
    <KycGenericVerification
      title="DL Verification"
      description="Verify driving license details for applicants."
      kycType="dl-verification"
      costField="dlVerificationCost"
      submitLabel="Submit DL Verification"
      inputs={[
        {
          name: 'dlNumber',
          label: 'DL Number',
          placeholder: 'DL-1234567890',
          maxLength: 30,
          validator: (value) => String(value || '').trim().length >= 5,
          errorMessage: 'DL Number is required'
        },
        {
          name: 'dob',
          label: 'Date of Birth',
          type: 'text',
          placeholder: 'DD/MM/YYYY',
          maxLength: 10,
          formatter: formatDobInput,
          transform: normalizeDob,
          validator: isValidDob,
          errorMessage: 'Use DOB as DDMMYYYY, DD-MM-YYYY, DD/MM/YYYY or YYYY-MM-DD'
        }
      ]}
      referenceFormatter={(item) => item.dlNumber || 'N/A'}
    />
  );
}
